//
//
//
//
//
//
//
//
//
//
//
//
//
//
import openArrowBtn from '~/assets/images/faq-button-open.svg';
export default {
  name: 'FaqQuestion',
  props: {
    faqQuestion: Object
  },

  data() {
    return {
      isOpen: false,
      imageUrl: openArrowBtn
    };
  },

  methods: {
    onclick(id) {
      this.isOpen = !this.isOpen;
      const element = document.getElementById(id);

      if (element.style.maxHeight) {
        element.style.maxHeight = null;
      } else {
        element.style.maxHeight = element.scrollHeight + 10 + 'px';
      }
    }

  }
};